import { user } from "modules/api/services";
import cryptoJs from "crypto-js";

export function login(email, password) {
  return user.post("/auth/login", {
    email,
    password: cryptoJs.SHA1(password).toString()
  });
}

export function tempLogin() {
  return user.post("/auth/temp/login");
}

export function getUser() {
  return user.get("/users/my");
}

export function updateUser(values) {
  return user.put("/users/my", values);
}

export function getHelpText(key) {
  return user.get(`/help/${key}`);
}

export function signUp(
  email,
  first_name,
  last_name,
  refreshToken,
  language,
  clinic_city,
  customer_id,
  ssn,
  phone
) {
  return user.post(`/auth/temp/register`, {
    email,
    first_name,
    last_name,
    language,
    refreshToken,
    clinic_city,
    customer_id,
    ssn,
    phone
  });
}

export function getSsnKey(ssn) {
  return user.post(`/auth/bankid`, {
    personalNumber: ssn,
    osd: true
  });
}

export function bankIdCollect(order_ref, personalNumber) {
  return user.post(`/auth/bankid/collect-osd`, {
    order_ref,
    osd: true,
    personalNumber: personalNumber
  });
}

export function confirmEmail(email, code, consent) {
  return user.post(`/auth/confirm`, {
    email,
    consent,
    code
  });
}

export function resendConfirmEmail(email) {
  return user.post(`/auth/confirm/resend`, {
    email
  });
}

export function fbLogin(token) {
  return user.post(`/auth/facebook/login`, {
    fb_token: token
  });
}

export function updatePassword(email, password, token) {
  return user.post(
    `/auth/password/update`,
    {
      email,
      password: cryptoJs.SHA1(password).toString()
    },
    {
      headers: {
        "Pass-Token": token
      }
    }
  );
}



// WEBPACK FOOTER //
// ./src/modules/api/user-effects.js